import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import { Component, createRef } from "react";
import { Link, withRouter } from "react-router-dom";

//  Images
import carrentIcon from "include/images/carrent-icon.svg";
import emptyIcon from "include/images/nrf.svg";
import plusIcon from "include/images/plus.svg";

import AlertError from "common/alert/alertError";
import DeleteModal from "common/alert/alertModal";
import AlertSuccess from "common/alert/alertSuccess";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { deleteAd, getTelegram, loadAds } from "store/telegram";
import AddAds from "./addAds";

class AdsListings extends Component {
  state = {
    loadingMain: false,
    loadingDelete: false,
    showAddModal: false,
    editData: null,
    cancelId: null,
    showDeleteModal: false,
  };
  ref = createRef(null);
  componentDidMount = () => {
    this.setState({ loadingMain: true });
    this.props.loadAds(() => {
      this.setState({ loadingMain: false });
    });
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (!this.props.getTelegram.adsLoading && this.props.getTelegram.adsLoading !== prevProps.getTelegram.adsLoading) {
      this.ref.current.complete();
    }
    if (this.props.getTelegram.adsLoading && this.props.getTelegram.adsLoading !== prevProps.getTelegram.adsLoading) {
      this.ref.current.continuousStart();
    }
    if (this.state.showAddModal !== prevState.showAddModal && !this.state.showAddModal) {
      this.setState({ editData: null });
    }
  };
  toggleAddModal = (e) => {
    if (e) e.preventDefault();
    this.setState({ showAddModal: !this.state.showAddModal });
  };
  cancelModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showDeleteModal: !this.state.showDeleteModal });
  };
  handleCancel = (e) => {
    this.setState({ loadingDelete: true });
    this.props.deleteAd(this.state.cancelId, (res) => {
      if (res?.status === 200) {
        toast(<AlertSuccess message="Deleted!" />, {
          containerId: 1,
        });
      } else {
        toast(<AlertError message={res.data && res.data.message} />, {
          containerId: 1,
        });
      }
      this.props.loadAds();
      this.cancelModalToggle();
      this.setState({ loadingDelete: false });
    });
  };
  render() {
    const { ads } = this.props.getTelegram;
    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="telegram-mini-app-settings-ads" />
          {!this.state.loadingMain && (
            <div className="main-content-wrapper position-relative">
              <div className="mcw-header d-flex align-items-center">
                <h1 className="camelCase">Ads</h1>
                <div className="filter-menu-box d-flex align-items-center ms-auto">
                  <div className="fmb-box">
                    <Link
                      to="#"
                      onClick={this.toggleAddModal}
                      className="btn btn-default btn-sm d-flex justify-content-center"
                    >
                      <img src={plusIcon} alt="" /> Add a Ad
                    </Link>
                  </div>
                </div>
              </div>
              <div className="fwc-wrapper">
                <div className="fwc-body">
                  {!this.state.loadingMain && (
                    <div className="table-responsive">
                      {ads.length === 0 ? (
                        <div className="fwc-body">
                          <div className="no-record-found-container">
                            <div className="nfr-box">
                              <img src={emptyIcon} alt="No Record Found" />
                              <div className="nrf-text">
                                <h5>No Records Found!</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <table className="table large-table text-capitalize">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center", width: 40 }}>Actions</th>
                              <th style={{ width: "22%" }}>Name</th>
                              <th style={{ width: "22%" }}>Block Id</th>
                              <th style={{ width: "22%" }}>Block Type</th>
                              <th>Reward</th>
                              <th>Status</th>
                              <th>Display Order</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ads?.map((ad, index) => (
                              <tr key={index}>
                                <td>
                                  <Dropdown className=" custom-dropdown">
                                    <Dropdown.Toggle
                                      id="tdDropdownOne"
                                      className={`custom-dropdown-toggle`}
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <img src={carrentIcon} alt="" />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className={`dropdown-menu-start `} aria-labelledby="tdDropdownOne">
                                      <Dropdown.Item
                                        className="dropdown-item"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.setState({ editData: ad }, () => {
                                            this.toggleAddModal();
                                          });
                                        }}
                                      >
                                        Edit
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        className="dropdown-item delete"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.setState({ cancelId: ad?._id }, () => {
                                            this.cancelModalToggle();
                                          });
                                        }}
                                      >
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                                <td>
                                  <Link
                                    to={`!#`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.setState({ editData: ad }, () => {
                                        this.toggleAddModal();
                                      });
                                    }}
                                  >
                                    <div class="small-text">{ad?.name}</div>
                                  </Link>
                                </td>
                                <td>{ad?.blockId}</td>
                                <td>{ad?.blockType}</td>
                                <td>{ad?.reward?.toLocaleString("en-us") ?? 0}</td>
                                <td>{ad?.status}</td>
                                <td>{ad?.displayOrder}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <AddAds showModal={this.state.showAddModal} toggleModal={this.toggleAddModal} edit={this.state.editData} />
        <DeleteModal
          alertModalToggle={this.cancelModalToggle}
          alertModalShow={this.state.showDeleteModal}
          alertType="Yes"
          title="Alert"
          description="Are you sure you want to delete this ad?"
          onPress={this.handleCancel}
          loading={this.state.loadingDelete}
        />
        {this.state.showAddModal && <div className="modal-backdrop show fade" onClick={this.toggleAddModal}></div>}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadAds: (callback) => dispatch(loadAds(callback)),
  deleteAd: (id, data, callback) => dispatch(deleteAd(id, data, callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdsListings));
